import type { LiteProducts } from '@fubotv/types/api/UP/products'

import {
  FETCH_PRODUCTS_FAIL,
  FETCH_PRODUCTS_SUCCESS,
  FetchProductsFailAction,
  FetchProductsSuccessAction,
  TRY_FETCH_PRODUCTS,
  TryFetchProductsAction,
} from '../actionTypes/'

export const tryFetchProducts = (): TryFetchProductsAction => {
  return {
    type: TRY_FETCH_PRODUCTS,
  }
}

export const fetchProductsSuccessful = ({
  products: plans,
  addons: addOns = [],
}: LiteProducts): FetchProductsSuccessAction => ({
  type: FETCH_PRODUCTS_SUCCESS,
  plans,
  addOns,
})

export const fetchProductsFail = (error: any): FetchProductsFailAction => ({
  type: FETCH_PRODUCTS_FAIL,
  error,
})
